import type { DeepPartial } from '@luna/utils-ts';

import type { Search } from '../../types/Search';

export const searchATFeatureConfig: DeepPartial<Search> = {
    countryProductId: 'WPDEPOT',
    fetchRiskAcceptance: true,
    showExperienceProfileMissingTooltip: true,
    showMarketPortalBanner: true,
};
